import React, { useEffect } from 'react';

const ShowreelModal = ({ onClose }) => {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal active" onClick={handleBackdropClick}>
      <div className="modal-content video-modal">
        <span className="close-modal" onClick={onClose}>&times;</span>
        <div className="video-container">
          <div className="video-placeholder">
            <h3>Showreel 2023</h3>
            <p>Video would play here in a real implementation</p>
            <div className="play-button">▶</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShowreelModal;